import { styled } from '@mui/material/styles'
import { themeBorderRadius, themeColor, themeSpacing } from 'eezy-components'
import { css } from 'styled-components'

import _ArrowDown from 'ez-styles/assets/icons/arrows/arrow-big-down.svg'
import _ArrowUp from 'ez-styles/assets/icons/arrows/arrow-big-up.svg'

type StickyProps = {
  open: boolean
  $isMobile?: boolean
}

export const StickyContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'open',
})<StickyProps>`
  position: fixed;
  bottom: ${themeSpacing(2)};
  left: ${themeSpacing(2)};
  z-index: 999;
  width: ${themeSpacing(50)};
  height: ${({ open }) => (open ? '70vh' : themeSpacing(17))};
  background-color: #fff;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.15);
  transition: height 0.25s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: ${themeBorderRadius('medium')};

  ${props =>
    props.$isMobile
      ? css`
          width: calc(100% - ${themeSpacing(2)});
          position: fixed;
          bottom: ${themeSpacing(1)};
          left: ${themeSpacing(1)};
        `
      : ''}
`

export const Header = styled('div')`
  display: flex;
  flex-direction: column;
  height: ${themeSpacing(17)};
  padding: ${themeSpacing(2)};
  padding-bottom: 0;
`

export const TitleWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const StatusWrapper = styled('div')`
  margin-top: ${themeSpacing(2)};
`

export const Content = styled('div')`
  flex: 1;
  padding: ${themeSpacing(2)};
  padding-top: 0;
  overflow-y: auto;
`

export const Section = styled('div')`
  padding: ${themeSpacing(1)} 0;
`

export const Separator = styled('div')`
  width: 100%;
  height: 1px;
  background-color: ${themeColor('secondary', 'pale')};
  margin: ${themeSpacing(2)} 0;
`

export const IconAction = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${themeColor('secondary', 'pale')};
  padding: ${themeSpacing(1)};
  width: ${themeSpacing(5.5)};
  height: ${themeSpacing(5.5)};
  border-radius: 50%;
  cursor: pointer;
`

export const ErrorWrapper = styled('div')`
  margin-top: ${themeSpacing(1)};
`

export const ArrowUp = styled(_ArrowUp)`
  fill: ${themeColor('secondary', 'main')};
  width: ${themeSpacing(1.75)};
  height: ${themeSpacing(1.75)};
`

export const ArrowUDown = styled(_ArrowDown)`
  fill: ${themeColor('secondary', 'main')};
  width: ${themeSpacing(1.75)};
  height: ${themeSpacing(1.75)};
`
